import React from "react";

const TargetOrderExecuteIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#odjyvdghma)">
        <path
          d="M8 0C3.584 0 0 3.584 0 8s3.584 8 8 8 8-3.584 8-8-3.584-8-8-8zM6.4 12l-4-4 1.128-1.128L6.4 9.736l6.072-6.072L13.6 4.8 6.4 12z"
          fill="#000"
        />
      </g>
      <defs>
        <clipPath id="odjyvdghma">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TargetOrderExecuteIcon;
